import React from 'react';
import Footer from '../Components/Regularizacion/Footer';
import WithYou from '../Components/Hooks/WithYou';
import RegistroContador from '../Components/RegistroContador/RegistroContador';
import NaviBar from '../Components/Aviso/NaviBar';

const RegContador = () => {
    return (
        <>
            <NaviBar/>
            <RegistroContador/>
            <WithYou />
            <Footer />
        </>
    );
}

export default RegContador;
